// extracted by mini-css-extract-plugin
export default {"table-container":"Dw58BPWbHNIlNLcbKivM","table-top-right-field":"Uo1yxmKk6u_nmArXp8X2","divider":"w5hkd2lPFj5SZt5sMyNL","table":"i2wyDhCy7YhH7Xu788WZ"};